import { capitalize, cloneDeep } from 'lodash'
import { observable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'

import ENUM from '../../ENUM'
import SubQuestion from './SubQuestion'

class CrossBreakSlide {
    id = uuidv4()

    kind = 'CrossBreakSlide'

    @observable comparisonSurveyIds

    @observable benchmarks

    @observable kpiPageQuestionId

    @observable questions = []

    comment

    constructor({
        benchmarks = [],
        comparisonSurveyIds = [],
        kpiPageQuestionId,
        questions = [],
    }) {
        this.benchmarks = benchmarks
        this.hasBenchmarks = benchmarks.length > 0

        this.comparisonSurveyIds = comparisonSurveyIds
        this.hasComparisons = comparisonSurveyIds.length > 0

        this.kpiPageQuestionId = kpiPageQuestionId
        this.questions = questions
    }

    static clone(slide) {
        return new CrossBreakSlide({
            benchmarks: slide.benchmarks.slice().map(cloneDeep),
            comparisonSurveyIds: slide.comparisonSurveyIds.slice().map(cloneDeep),
            kpiPageQuestionId: slide.kpiPageQuestionId,
            questions: slide.questions.slice().map((q) => SubQuestion.clone(q)),
        })
    }

    arrayOrUndefined = (arr) => {
        const checked = Array.isArray(arr)
            ? arr.filter(({ checked }) => checked)
            : []

        return checked.length > 0
            ? checked.map(({ value }) => capitalize(value))
            : undefined
    }

    toJSON() {
        return {
            kind: this.kind,
            // comparisonSurveyIds: this.arrayOrUndefined(this.comparisonSurveyIds.slice()),
            comparisonSurveyIds: undefined, // temporarily disabling comparison years
            benchmarks: this.arrayOrUndefined(this.benchmarks.slice()),
            kpiPageQuestionId: this.kpiPageQuestionId,
            questions: this.questions.slice().map((q) => q.toJSON()),
            comment: this.comment,
        }
    }

    getRankingOptions = () => (
        [
            {
                label: ENUM().noRanking,
                value: 'noRanking',
                name: ENUM().ranking,
            },
            {
                label: ENUM().lowToHigh,
                value: 'lowToHigh',
                name: ENUM().ranking,
            },
            {
                label: ENUM().highToLow,
                value: 'highToLow',
                name: ENUM().ranking,
            },
            {
                label: ENUM().aToZ,
                value: 'aToZ',
                name: ENUM().ranking,
            },
        ]
    )
}

export default CrossBreakSlide
